module.exports = __webpack_public_path__ + "img/02_sub_no.66318300.svg";